import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export interface PanigationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Panigation: React.FC<PanigationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => (
  <div className="flex items-center justify-center gap-1 sm:gap-2 py-4 flex-wrap">
    <button
      onClick={() => onPageChange(currentPage - 1)}
      disabled={currentPage === 1}
      className="flex items-center gap-1 !px-2 sm:!px-3 !py-1.5 !text-xs sm:!text-sm !text-gray-500 dark:!text-dark-text-secondary hover:!text-gray-700 dark:hover:!text-white disabled:!opacity-50 !bg-transparent !border-none"
    >
      <div className='bg-primary dark:bg-dark-border p-2 rounded-full'>
        <ChevronLeft className="w-4 h-4 text-white" />
      </div>
    </button>
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <button
        key={page}
        onClick={() => onPageChange(page)}
        className={`!w-7 sm:!w-8 !h-7 sm:!h-8 !rounded !text-xs sm:!text-sm !border-none ${
          currentPage === page
            ? '!bg-primary dark:!bg-dark-border !text-white'
            : '!bg-transparent !text-gray-500 dark:!text-dark-text-secondary hover:!text-gray-700 dark:hover:!text-white'
        }`}
      >
        {page}
      </button>
    ))}
    <button
      onClick={() => onPageChange(currentPage + 1)}
      disabled={currentPage === totalPages}
      className="flex items-center gap-1 !px-2 sm:!px-3 !py-1.5 !text-xs sm:!text-sm !text-gray-500 dark:!text-dark-text-secondary hover:!text-gray-700 dark:hover:!text-white disabled:!opacity-50 !bg-transparent !border-none"
    >
      {/* <span className="hidden sm:inline">Next</span> */}
      <div className='bg-primary dark:bg-dark-border p-2 rounded-full'>
        <ChevronRight className="w-4 h-4 text-white" />          
      </div>
    </button>
  </div>
);
